(() => {
  'use strict';

  const PARAMETER = 'lk_campaign_ref';
  const STORAGE_KEY = 'lk_campaign_attribution_v1';
  const REFERENCE_PATTERN = /^lkc_[a-f0-9]{32}$/i;
  const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

  function readPendingReference() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (
        !value ||
        !REFERENCE_PATTERN.test(value.reference) ||
        !Number.isFinite(value.capturedAt) ||
        Date.now() - value.capturedAt > MAX_AGE_MS
      ) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return value;
    } catch (_error) {
      return null;
    }
  }

  function captureUrlReference() {
    const reference = new URL(window.location.href).searchParams.get(PARAMETER);
    if (!REFERENCE_PATTERN.test(reference || '')) return null;

    const value = { reference, capturedAt: Date.now() };
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (_error) {
      // Storage can be blocked; the current-page reference can still be synced.
    }
    return value;
  }

  function clearSyncedReference(reference) {
    try {
      const pending = readPendingReference();
      if (pending?.reference === reference) {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (_error) {
      // Attribution must never interrupt the storefront.
    }
  }

  async function syncReference() {
    const attribution = captureUrlReference() || readPendingReference();
    if (!attribution) return;

    const root = window.Shopify?.routes?.root || '/';
    const response = await window.fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [PARAMETER]: attribution.reference } }),
      keepalive: true,
    });
    if (!response.ok) return;

    const cart = await response.json();
    if (cart.attributes?.[PARAMETER] === attribution.reference) {
      clearSyncedReference(attribution.reference);
    }
  }

  const start = () => syncReference().catch(() => {});
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
